import { commonProps } from '@duda-co/host-services';

export const isStaticPageBindingDropdownEnabled = () =>
    commonProps.getFlag(
        'siteCollection.staticBinding.dropdown.pages.enabled',
        false
    );

export const isIdentifierCellUpdateFixEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.identifierCell.update.fix.enabled',
        false
    );

export const isCollectionsJSapiFilterValidationEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.jsApi.filter.validations.enalbed',
        false
    );

export const isFiltersAndAddButtonEnabled = () =>
    commonProps.getFlag('ecom.collections.filtersAndAddRow.enabled', true);

export const isSingleSelectFieldEnabled = () =>
    commonProps.getFlag('ecom.collections.single.select.field.enabled', false);

export const isDynamicPageFieldEnabled = () =>
    commonProps.getFlag('ecom.collections.dynamic.page.field.enabled', false);

// LD key kept as-is to preserve existing per-site targeting; the JS name
// reflects what the flag actually gates today (the anchor section inside the
// LINK cell's link picker). Dynamic-page selection lives in DYNAMIC_PAGE.
export const isAnchorLinkSectionEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.link.type.dynamic.page.enabled',
        false
    );

export const isEmailFieldMultiSelectEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.email.field.multiselect.enabled',
        false
    );

export const isPhoneFieldPickerEnabled = () =>
    commonProps.getFlag('ecom.collections.phone.field.picker.enabled', false);

export const isImageCellHoverPreviewEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.image.cell.hover.preview.enabled',
        false
    );

export const isUpdateErrorUxEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.externalCollectionPanel.updateErrorUx.enabled',
        false
    );

export const isNewCollectionsPanelEnabled = () =>
    commonProps.getFlag('ecom.collections.newPanel.enabled', false);

export const isExternalCollectionsLangCorrelationEnabled = () =>
    commonProps.getFlag(
        'ecom.collections.external.lang.correlation.enabled',
        false
    );

export const isCreateCollectionWithAiEnabled = () =>
    commonProps.getFlag('ecom.collections.create.with.ai.enabled', false);

// The editor's own Copilot gate (isAiChatInEditorEnabled in the monolith).
export const isCopilotInEditorEnabled = () =>
    commonProps.getFlag('mcp.chat.in.editor.enabled', true);
